import styled from '../../styled/index';
import fromTheme from '../../fromTheme';


const DatePickerWrapper = styled.div.attrs({ className: 'datepicker-wrapper' })`
    --background-color: ${fromTheme('datepicker', 'backgroundColor')};
    --border-radius: ${fromTheme('datepicker', 'borderRadius')};
    --border-color: ${fromTheme('datepicker', 'borderColor')};
    --padding: ${fromTheme('datepicker', 'padding')};

    --header-background-color: ${fromTheme('datepicker', 'header', 'backgroundColor')};
    --header-font-color: ${fromTheme('datepicker', 'header', 'fontColor')};
    --header-font-family: ${fromTheme('datepicker', 'header', 'fontFamily')};
    --header-font-size: ${fromTheme('datepicker', 'header', 'fontSize')};
    --header-font-style: ${fromTheme('datepicker', 'header', 'fontStyle')};
    --header-font-weight: ${fromTheme('datepicker', 'header', 'fontWeight')};
    --header-line-height: ${fromTheme('datepicker', 'header', 'lineHeight')};
    --header-margin-top: ${fromTheme('datepicker', 'header', 'marginTop')};
    --header-margin-bottom: ${fromTheme('datepicker', 'header', 'marginBottom')};

    --day-name-font-color: ${fromTheme('datepicker', 'dayName', 'fontColor')};
    --day-name-font-family: ${fromTheme('datepicker', 'dayName', 'fontFamily')};
    --day-name-font-size: ${fromTheme('datepicker', 'dayName', 'fontSize')};
    --day-name-font-style: ${fromTheme('datepicker', 'dayName', 'fontStyle')};
    --day-name-font-weight: ${fromTheme('datepicker', 'dayName', 'fontWeight')};
    --day-name-line-height: ${fromTheme('datepicker', 'dayName', 'lineHeight')};
    --day-name-width: ${fromTheme('datepicker', 'dayName', 'width')};

    --day-font-color: ${fromTheme('datepicker', 'day', 'default', 'fontColor')};
    --day-font-family: ${fromTheme('datepicker', 'day', 'fontFamily')};
    --day-font-size: ${fromTheme('datepicker', 'day', 'fontSize')};
    --day-font-style: ${fromTheme('datepicker', 'day', 'fontStyle')};
    --day-font-weight: ${fromTheme('datepicker', 'day', 'default', 'fontWeight')};
    --day-line-height: ${fromTheme('datepicker', 'day', 'lineHeight')};
    --day-width: ${fromTheme('datepicker', 'day', 'width')};
    --day-padding-top-bottom: ${fromTheme('datepicker', 'day', 'paddingTopBottom')};
    --day-padding-left-right: ${fromTheme('datepicker', 'day', 'paddingLeftRight')};
    --day-border-radius: ${fromTheme('datepicker', 'day', 'borderRadius')};

    --outside-month-day-font-color: ${fromTheme('datepicker', 'day', 'outsideMonth', 'fontColor')};

    --selected-day-font-color: ${fromTheme('datepicker', 'day', 'selected', 'fontColor')};
    --selected-day-background-color: ${fromTheme('datepicker', 'day', 'selected', 'backgroundColor')};
    --selected-day-font-weight: ${fromTheme('datepicker', 'day', 'selected', 'fontWeight')};

    --hover-day-font-color: ${fromTheme('datepicker', 'day', 'hover', 'fontColor')};
    --hover-day-background-color: ${fromTheme('datepicker', 'day', 'hover', 'backgroundColor')};
    --hover-day-font-weight: ${fromTheme('datepicker', 'day', 'hover', 'fontWeight')};

    --today-font-color: ${fromTheme('datepicker', 'day', 'today', 'fontColor')};
    --today-background-color: ${fromTheme('datepicker', 'day', 'today', 'backgroundColor')};
    --today-font-weight: ${fromTheme('datepicker', 'day', 'today', 'fontWeight')};

    --navigation-padding-top: ${fromTheme('datepicker', 'navigation', 'paddingTop')};
    --navigation-padding-right: ${fromTheme('datepicker', 'navigation', 'paddingRight')};
    --navigation-icon-color: ${fromTheme('datepicker', 'navigation', 'color')};
    --navigation-border-width: ${fromTheme('datepicker', 'navigation', 'borderWidth')};

    --month-time-divider-style: ${({showTimeInput}) => showTimeInput ? 'solid' : 'none'};
    --month-time-divider-width: ${({showTimeInput}) => showTimeInput ? fromTheme('datepicker', 'monthTimeDivider', 'width') : 0};
    --month-time-divider-color: ${fromTheme('datepicker', 'monthTimeDivider', 'color')};
    --month-time-divider-bottom-padding: ${fromTheme('datepicker', 'monthTimeDivider', 'paddingBottom')};

    --timepicker-margin-left: ${fromTheme('datepicker', 'timepicker', 'marginLeft')};
    --timepicker-margin-top: ${fromTheme('datepicker', 'timepicker', 'marginTop')};
    width: 100%;
`;

export default DatePickerWrapper;